import http from '@/communication/AuthConnection'

export default async (payload) => {
  const { data } = await http.post(`/v1/result/item`, payload)
  if (data.success) {
    return true
  } else {
    return Promise.reject(Error('Não foi possível carregar a listagem'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/result/save-item/SaveItem.js